const x_accordion_init = (accordion, i) => {
  let tab = accordion;
  let panel = accordion.parentNode.parentNode.querySelector('.subcategories__prodcat__list');
  let panelImage = accordion.parentNode.parentNode.querySelector('.subcategories__prodcat__image');

  tab.setAttribute('aria-controls', 'accordion-' + i);
  panel.setAttribute('id', 'accordion-' + i);
  panel.setAttribute('aria-labelledby', 'accordion-' + i);

  panelImage.setAttribute('id', 'accordion-' + i);
  panelImage.setAttribute('aria-labelledby', 'accordion-' + i);
};

const x_accordion_focus = (e) => {
  let tab = e.currentTarget;

  if (tab.getAttribute('aria-selected') === 'true') {
    tab.setAttribute('aria-selected', 'false');
  } else {
    tab.setAttribute('aria-selected', 'true');
  }
};

const x_accordion_toggle = (e) => {
  e.stopPropagation();

  let tab = e.currentTarget;
  let panel = e.currentTarget.parentNode.parentNode.querySelector('.subcategories__prodcat__list');
  let panelImage = e.currentTarget.parentNode.parentNode.querySelector('.subcategories__prodcat__image');

  if (tab.getAttribute('aria-expanded') === 'true') {
    tab.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panelImage.setAttribute('aria-hidden', 'false');
  } else {
    tab.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panelImage.setAttribute('aria-hidden', 'true');
  }
};

const x_accordion_find_and_init = () => {
  let accordion = document.querySelectorAll('.subcategories__prodcat__icon-wrapper');
  for (let i = 0; i < accordion.length; i++) {
    x_accordion_init(accordion[i], i);

    accordion[i].addEventListener('click', x_accordion_toggle);
    accordion[i].addEventListener('focus', x_accordion_focus);
    accordion[i].addEventListener('blur', x_accordion_focus);
  }
};

x_accordion_find_and_init();